import React from 'react'
import "./Hero.css"
function Hero() {

  return (
    <>
    <div className='singleRoomBanner relative'>    
    </div>
    </>
  )
}

export default Hero